<template>
  <div>
    <gg-card>
      <v-card-title class="d-block text-left">
        <h3>Why are you disabling auto-renewal?</h3>
      </v-card-title>

      <v-card-text>
        <v-radio-group v-model="reason">
          <v-radio v-for="reason in this.cr_reasons_list"
                   :key="reason.id"
                   :label="reason.name"
                   :value="reason"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <gg-btn secondary @click="cancelCR" tile elevation="0" :loading="crCancelLoading">Cancel</gg-btn>
        <gg-btn
          :disabled="!reasonSelected"
          :loading="loading_cr"
          color="primary"

          tile elevation="0"
          @click="callCRGuided"
        >
          Next
        </gg-btn>
      </v-card-actions>
    </gg-card>

    <offer-modal
      :opened="dialog"
      @accepted="offerAccepted"
      @declined="offerDeclined"
      @close="dialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import crCloseMixin from '@/mixins/crClose'
import OfferModal from './OfferModal'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'CancelReasons',
  components: { OfferModal },
  mixins: [crCloseMixin],
  data: () => ({
    reason: null,
    isReasonsLoaded: false,
    assistance_option: '',
    loading_cr: false,
    loading_accept_offer: false,
    dialog: false,
    show_dialog_component: false
  }),
  computed: {
    ...mapGetters(['cr_reasons_list', 'cr_id', 'cr_guided', 'services', 'domains']),
    reasonSelected () {
      return !!this.reason?.id
    },
    showOffer () {
      return this.assistance_option !== ''
    },
  },
  async created () {
    await this.getReasonsList()
  },
  methods: {
    ...mapActions(['reportSuccess', 'reportError', 'getCRReasons', 'sendCRGuided', 'sendCROpen', 'getServices']),
    stepBack () {
      this.$emit('step-back')
    },
    async getReasonsList () {
      try {
        await this.getCRReasons(this.buildCRRequestParameters())

        if (this.$route.query.type === cancellationTypes.ID_PROTECT) {
          const data = {
            cr_id: this.cr_id,
          }
          // const response = await this.sendCROpen(data)
          // this.reportSuccess(response.resultmsg)
          // this.getServices()
          this.$emit('cr-opened', {
            tpl: 'cr_open',
            response: data
          })
        }

        if (this.$route.query.type !== 'hosting') {
          this.$emit('go-to-last-step')
        }

        this.$emit('page-loaded')
      } catch (e) {
        this.reportError(e)
        await this.$router.push({ name: 'dashboard' })
      }
    },
    async callCRGuided () {
      try {
        this.loading_cr = true
        this.show_dialog_component = true

        const data = {
          reason: Number(this.reason.id),
          cr_id: Number(this.cr_id),
        }

        this.$emit('set-comment', {
          required: this.reason.comment_required,
          question: this.reason.comment_question
        })

        const response = await this.sendCRGuided(data)

        if (response.offer === false) {
          this.$emit('no-offer')
          this.loading_cr = false
          return
        }

        this.$emit('set-additional-question', this.reason.question)

        this.dialog = true
        this.loading_cr = false
      } catch (e) {
        this.loading_cr = false
        this.reportError(e)
      }
    },
    async cancelCR () {
      try {
        await this.crClose(this.cr_id)
      } catch (e) {
        this.reportError(e.resultmsg)
      } finally {
        this.$emit('cancel')
      }
    },
    offerAccepted (response) {
      this.getServices()
      this.$emit('offer-accepted', {
        step: 4,
        tpl: 'cr_escalate',
        response
      })
      this.assistance_option = ''
    },
    offerDeclined () {
      this.$emit('offer-declined')
      this.assistance_option = ''
    },
    buildCRRequestParameters () {
      const type = this.$route.query.type
      const currentServiceId = this.$route.params.service_id
      let serviceId = currentServiceId
      let addons = []
      const currentService = this.services.find(service => service.id == currentServiceId)
      const currentDomain = this.domains.find(domain => domain.id == currentServiceId)
      switch (type) {
        case cancellationTypes.ADDON:
          serviceId = currentService.related_service
          addons = [currentServiceId]
          break
        case cancellationTypes.DOMAIN:
          addons = [currentDomain.idprotect_serviceid]
          break
        case cancellationTypes.HOSTING:
        default:
          addons = this.services.filter((service) => service.related_service == serviceId)
            .map((service) => service.id)
      }
      return {
        type,
        service_id: serviceId,
        addons: JSON.stringify(addons),
      }
    }
  }
}
</script>
